import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { useRef } from "react";
import { createPortal } from "react-dom";
import { CSSTransition } from "react-transition-group";
import styled, { css } from "styled-components";
import { zIndexLayers } from "../../common/zIndexLayers";
import { useClickEscape } from "../../core/hooks/useClickOutside";
import { LockBodyStyles } from "../../theme/global-style";
import { animationStyles, ModalContent, positionStyles } from "./style/Blocks";
const _Modal = (props) => {
    const { isOpen, disabled, onClickOutside = props.onClose, onClickEscape = props.onClose, hasOverlay = true, position = "center", container = document.body, children, lockBody = true, zIndex = zIndexLayers.modal, animation = "fade", unmountOnExit = true, fullSize, maxWidth, size, hidden, } = props;
    const ref = useRef(null);
    // useClickOutside({
    //   isActive: !disabled && isOpen && !hidden,
    //   ref,
    //   handler: typeof onClickOutside === "function" && !hidden ? onClickOutside : () => void 0,
    // });
    useClickEscape({
        isActive: !disabled && isOpen && !hidden,
        handler: typeof onClickEscape === "function" && !hidden ? onClickEscape : () => void 0,
    });
    return createPortal(_jsxs(_Fragment, { children: [isOpen && lockBody ? _jsx(LockBody, {}) : null, _jsx(CSSTransition, { in: isOpen, timeout: 300, classNames: animation, unmountOnExit: unmountOnExit, mountOnEnter: true, children: _jsxs(Wrapper, { className: props.className, "$zIndex": zIndex, "$animation": animation, onClick: () => onClickOutside?.(), children: [hasOverlay && _jsx(Overlay, { "$hidden": hidden, "aria-label": "Overlay" }), _jsx(SubWrapper, { children: _jsx(Flex, { position: position, children: _jsx(ModalContent, { "$position": position, "$maxWidth": maxWidth, ref: ref, "$fullSize": fullSize, "$size": size, onClick: (e) => e?.stopPropagation?.(), children: children }) }) })] }) })] }), container);
};
const Wrapper = styled.div `
  z-index: ${({ $zIndex }) => $zIndex};
  position: fixed;
  top: 0;
  right: 0;
  left: 0;
  bottom: 0;
  height: 100%;
  transition: opacity 300ms;

  *,
  *::before,
  *::after {
    box-sizing: border-box;
  }

  ${({ $animation }) => animationStyles[$animation]};
`;
const SubWrapper = styled.div `
  position: absolute;
  top: 0;
  right: 0;
  left: 0;
  bottom: 0;
  padding: 16px;
  overflow: hidden;
  height: 100%;
`;
const Flex = styled.div `
  min-height: 100%;
  height: 100%;

  display: flex;
  overflow: hidden;

  ${(p) => css `
    align-items: ${positionStyles[p.position][0]};
    justify-content: ${positionStyles[p.position][1]};
  `}
`;
const Overlay = styled.div `
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  opacity: ${({ $hidden }) => ($hidden ? 0 : 0.3)};
  transition: opacity 0.3s ease;
  background-color: ${(p) => p.theme.systemColors.grey400};
`;
export const LockBody = () => {
    const needScrollBar = !!(document.body.scrollHeight - document.body.clientHeight);
    return needScrollBar ? _jsx(LockBodyStyles, {}) : _jsx(_Fragment, {});
};
export const Modal = Object.assign(_Modal, {
    Overlay,
    Content: ModalContent,
    Wrapper,
    SubWrapper,
    Flex,
});
